import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Layout, { Content, Header } from 'antd/lib/layout/layout'
import Logo from './logo'

import RegionSelector from './components/regionSelector'
import LanguageSelector from './components/languageSelector'
import NotFound from './components/notFound'

import Footer from './components/footer'
import Document from './document'

import './App.css'

import config from './config.json'

const App = () => {
  const {
    region: regionParam = 'mex',
    lang: langParam = 'es',
    filename: fileParam = 'terminos-y-condiciones'
  } = useParams()

  const [region] = useState(regionParam)
  const [language] = useState(langParam)
  const [filename] = useState(fileParam)

  const availableRegions = Object.keys(config)
  const availableLanguages = Object.keys(config[region] || {})
  let availableDocuments = {}

  if (!config[region]) window.location = `/mex/es/${filename}`

  if (config[region][language]) availableDocuments = config[region][language]

  useEffect(() => {
    if (
      language &&
      availableLanguages.length > 0 &&
      !availableLanguages.includes(language)
    ) window.location = `/${region}/${availableLanguages[0]}/${filename}`

    if (
      !availableRegions.includes(region)
    ) window.location = `/mex/es/${filename}`
  }, [language, availableLanguages, filename, region, availableRegions])

  return (
    <Layout className='App'>
      <Header className='Header'>
        <Logo />
        <RegionSelector availableRegions={availableRegions} />
      </Header>

      <Content className='Content'>
        {
          availableDocuments[filename]
            ? (
              <div className='Center'>
                <LanguageSelector
                  availableLanguages={availableLanguages}
                  language={language}
                  filename={filename}
                  region={region}
                />
                <Document
                  region={region}
                  language={language}
                  filename={filename}
                  availableDocuments={availableDocuments}
                />
              </div>
              )
            : <NotFound />
        }
      </Content>
      <Footer availableDocuments={Object.keys(availableDocuments)} />
    </Layout>
  )
}

export default App
